<div class="main-delete">
  <button class="close-btn" type="button" (click)="cancel()">
    <mat-icon>close</mat-icon>
  </button>

  <div class="text-part">
    <span class="text-part-title">{{ 'fee.remove_user_from_subgroup' | translate }}</span>
    <span class="text-part-info">{{ 'fee.remove_user_from_subgroup_description' | translate:{ group: data.subgroup.groupName || ('fee.group' | translate), subgroup: data.subgroup.name } }}</span>
  </div>
  <div class="action-part">
    <button class="option-cancel option-shared" (click)="cancel()">{{ 'Cancel' | translate }}</button>
    <button class="option-remove option-shared" [disabled]="removing" (click)="confirm()">
      @if (removing) {
        <mat-progress-spinner diameter="16" mode="indeterminate"></mat-progress-spinner>
      } @else {
        {{ 'fee.remove' | translate }}
      }
    </button>
  </div>
</div>
